import api from "@/apis/bussiness/exploitDBAPI";
import Crud from "./crudBase";
var crud = new Crud("exploitDB", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "edb_id",
      code: "edb_id",      
    }
  },  
};
const getters = {
  ...crud.getters
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations  
};

export default {
  debug: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
